import { render, staticRenderFns } from "./assessment-history-chart.vue?vue&type=template&id=27c4b492&"
import script from "./assessment-history-chart.vue?vue&type=script&lang=js&"
export * from "./assessment-history-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports